// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.fb-button[data-v-595cc22a] {\n\tbackground-color: white;\n\tborder-radius: 5px;\n\tpadding:8px 10px;\n\twidth:100%;\n\tfont-size: 14px;\n\ttext-align: center;\n\tcolor: #3c4043;\n\tcursor: pointer;\n\tborder: 2px solid rgb(226, 224, 224);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
